<template>
  <v-row dense>

    <!-- 開始ページ -->
    <v-col :lg="textFieldCols.lg" :md="textFieldCols.md" :sm="textFieldCols.sm">
      <v-text-field
        v-model="rangeStart"
        label="開始ページ"
        outlined
        :rules="rules"
        color="secondary"
        dense
      ></v-text-field>
    </v-col>

    <div class="text">から</div>

    <!-- 終了ページ -->
    <v-col :lg="textFieldCols.lg" :md="textFieldCols.md" :sm="textFieldCols.sm">
      <v-text-field
        v-model="rangeEnd"
        label="終了ページ"
        outlined
        :rules="rules"
        color="secondary"
        dense
      ></v-text-field>
    </v-col>

    <!-- 追加ボタン -->
    <div v-if="showAddBtn">
      <v-btn color="secondary" @click.stop="$emit('add-range')">追加</v-btn>
    </div>

    <!-- 削除ボタン -->
    <div class="delete_area" v-if="showRemoveBtn">
      <v-icon class="delete-icon" color="red" dark fab @click.stop="$emit('remove-range')">
        mdi-close-circle
      </v-icon>
    </div>
  </v-row>
</template>

<script>
export default {
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    showAddBtn: {
      type: Boolean,
      default: false,
    },
    showRemoveBtn: {
      type: Boolean,
      default: false,
    },
    textFieldCols: {
      type: Object,
      default: () => ({ lg: 3, md: 3, sm: 4 }),
    }
  },

  data: () => ({
    rules: [
      value => !value.match(/[^0-9]/) || '数字のみで入力してください',
    ],
  }),

  computed: {
    rangeStart: {
      get() {
        return this.start;
      },
      set(value) {
        this.$emit('update-start', this.convertHalf(value))
      }
    },

    rangeEnd: {
      get() {
        return this.end;
      },
      set(value) {
        this.$emit('update-end', this.convertHalf(value))
      }
    },

    hasError() {
      return !!this.rangeStart.match(/[^0-9]/) || !!this.rangeEnd.match(/[^0-9]/)
    }
  },

  watch: {
    hasError(now) {
      this.$emit('update-error', now)
    }
  },

  methods: {
    // 全角数字を半角へ変換
    convertHalf(text) {
      return text.replace(/[０-９]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
    },
  },
}
</script>

<style lang="stylus" scoped>
  div
    text-align: center;
    line-height: 45px;

  .delete-icon
    cursor pointer

  .delete_area
    min-width 64px
    text-align left

</style>
